import { useRecordContext } from "ra-core";

import type { Contact } from "../types";

export const ContactBackgroundInfo = () => {
  const record = useRecordContext<Contact>();

  if (!record?.background) {
    return <div className="text-sm text-muted-foreground">Нет заметки</div>;
  }

  return <div className="whitespace-pre-wrap text-sm">{record.background}</div>;
};
